module.exports = __webpack_public_path__ + "img/LUB00259.67046191.png";